import { useEffect, useState } from 'react';

/**
 * Returns a debounced version of `value` that only updates after `delay`
 * milliseconds of no changes. Use for search inputs so the query fires
 * as the user pauses typing, not on every keystroke.
 */
export function useDebounced<T>(value: T, delay = 300): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return debounced;
}
